/**
 * Youth page: Молодёжка — общение, рост и вера для подростков и молодёжи.
 * Static content, events to be added later.
 */

import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout } from "../../components/layout/index.ts";
import { IconChevronRight } from "../../components/Icons.tsx";
import { getTelegram } from "../../lib/telegram.ts";

const BODY_TEXT = `Молодёжка — это место, где можно быть собой, задавать вопросы и находить друзей.

Здесь мы вместе разбираемся в жизни, делимся мыслями, молимся и просто хорошо проводим время.

Ждём тебя на наших встречах — приходи сам и зови друзей!`;

export function YouthPage() {
  const navigate = useNavigate();
  const tg = getTelegram();

  useEffect(() => {
    if (!tg) return;
    tg.BackButton.show();
    const handleBack = () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/");
      }
    };
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
      tg.BackButton.hide();
    };
  }, [tg, navigate]);

  return (
    <Layout>
      <h1 className="text-xl font-bold text-slate-800 mb-4">Молодёжка</h1>

      {/* Description */}
      <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm p-4 xs:p-5 border border-slate-100">
        <p className="text-slate-600 text-sm leading-relaxed whitespace-pre-wrap prose prose-slate prose-sm max-w-none">
          {BODY_TEXT}
        </p>
      </div>

      {/* Placeholder for future events */}
      <div className="mt-6 rounded-2xl overflow-hidden bg-white/80 backdrop-blur-sm shadow-sm p-6 text-center border border-slate-100">
        <p className="text-slate-500 text-sm font-medium uppercase tracking-wider">
          Скоро
        </p>
        <p className="text-slate-600 text-sm mt-1">
          Мероприятия появятся здесь
        </p>
      </div>

      <div className="mt-6">
        <Link
          to="/schedule"
          className="flex items-center justify-between gap-3 py-4 px-4 rounded-xl bg-white/95 shadow-sm border border-slate-100 active:bg-slate-50 transition-colors no-underline text-inherit"
        >
          <span className="font-medium text-slate-800">
            Всё расписание на неделю
          </span>
          <IconChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
        </Link>
      </div>

      <div className="h-4" />
    </Layout>
  );
}
